import React, { useEffect, useState } from 'react';
import { Table, SearchInput } from 'components';
import { FormDetail } from './form-detail';
import { Box, Button, IconButton } from '@mui/material';
import { BsArrowDownCircle, BsArrowUpCircle, BsPlus, BsFilter } from 'react-icons/bs';
import ApiServices from 'services';

function ClientCareProcess() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selected, setSelected] = useState(null);

  const initData = async () => {
    setLoading(true);
    try {
      const { data } = await ApiServices.getClientCareProcess();
      setData(data || []);
    } catch (err) {
      console.warn('initData - Client Care Process', err);
    }
    setLoading(false);
  };
  useEffect(() => {
    initData();
  }, []);
  const deleteCell = async (row) => {
    setLoading(true);
    try {
      const res = await ApiServices.deleteClientCareProcess(row.id);
      console.log(res);

      if (res) {
        window.UIMessage?.success('Xóa thành công');
        initData();
      }
    } catch (err) {
      window.UIMessage?.error('Xóa thất bại !!!');
      console.warn('deleteCell - companies', err);
    }
    setLoading(false);
  };
  const headCells = [
    {
      id: 'code',
      numeric: false,
      disablePadding: false,
      label: 'Mã',
      width: 10,
      sort: true,
      align: 'left',
    },
    {
      id: 'name',
      numeric: true,
      disablePadding: false,
      label: 'Tên Bước',
      align: 'left',
    },
    {
      id: 'levelIndex',
      numeric: true,
      disablePadding: false,
      label: 'Thứ Tự Bước',
      align: 'left',
    },
    {
      id: 'clientStatusName',
      numeric: true,
      disablePadding: false,
      label: 'Trạng Thái Áp Dụng',
      align: 'left',
    },
    {
      id: 'serviceName',
      numeric: true,
      disablePadding: false,
      label: 'Dịch Vụ Áp Dụng',
      align: 'left',
    },
    {
      id: 'note',
      numeric: true,
      disablePadding: false,
      label: 'Ghi Chú',
      align: 'left',
    },
    {
      id: 'actions',
      numeric: true,
      disablePadding: false,
      width: '10px',
      fixed: 'right',
      label: 'Thao tác',
      render: (row) => (
        <Button
          variant="contained"
          size="small"
          color="error"
          sx={{ borderRadius: '15px', textTransform: 'none' }}
          onClick={() => window.showConfirm(() => deleteCell(row))}
        >
          Xoá
        </Button>
      ),
    },
  ];
  return (
    <>
      <Box sx={{ width: '100%' }}>
        <Table
          rows={data}
          headCells={headCells}
          onClickDetail={(row) => {
            setSelected(row);
          }}
          title="Quy Trình Chăm Sóc"
          loading={loading}
          renderHeader={() => {
            return (
              <>
                <SearchInput sx={{ mr: 2 }} />
                <Box
                  sx={{
                    flex: 1,
                    display: 'flex',
                    justifyContent: 'flex-end',
                    flexWrap: 'wrap',
                    mr: 2,
                  }}
                >
                  <IconButton aria-label="filter" sx={{ color: '#6C757D' }}>
                    <BsFilter />
                  </IconButton>
                  <Button
                    variant="outlined"
                    startIcon={<BsArrowDownCircle />}
                    size="small"
                    sx={{
                      textTransform: 'none',
                      borderRadius: '10px',
                      marginLeft: '8px',
                      color: '#6C757D',
                      border: '1px solid rgba(0, 0, 0, 0.4)',
                      padding: '0px 8px',
                    }}
                  >
                    Nhập excel
                  </Button>
                  <Button
                    variant="outlined"
                    startIcon={<BsArrowUpCircle />}
                    size="small"
                    sx={{
                      textTransform: 'none',
                      borderRadius: '10px',
                      marginLeft: '8px',
                      color: '#6C757D',
                      border: '1px solid rgba(0, 0, 0, 0.4)',
                      padding: '0px 8px',
                    }}
                  >
                    Tải excel
                  </Button>
                  <Button
                    variant="contained"
                    size="small"
                    endIcon={<BsPlus />}
                    sx={{
                      borderRadius: '20px',
                      // padding: "7px 15px",
                      textTransform: 'none',
                      marginLeft: '8px',
                      color: '#FFFFFF',
                      backgroundColor: '#21409A',
                      '.MuiButton-endIcon': {
                        marginLeft: '0px',
                      },
                      padding: '0px 10px',
                    }}
                    onClick={() => setSelected({ isNew: true })}
                  >
                    Thêm mới
                  </Button>
                </Box>
              </>
            );
          }}
        />
        <FormDetail {...{ selected, setSelected, initData }} />
      </Box>
    </>
  );
}
export { ClientCareProcess };
